module.exports = __webpack_public_path__ + "img/tag_gk@2x.56afc783.svg";